

import { sanitizeFilename } from "../sanitizeFilename";

export function realWorldTaskToPptDocument(
result)
{
  const slides = [
  {
    kind: "title",
    title: result.pageTitle,
    subtitle: `${result.curriculumLabel} · ${result.difficultyLabel}`
  },
  {
    kind: "section",
    title: "Real-world tasks",
    body: `${result.tasks.length} classroom-ready scenarios for ${result.topicLabel}`
  },
  ...result.tasks.flatMap((task, index) => [
  {
    kind: "bullets",
    title: `Task ${index + 1} · ${task.title}`,
    bullets: [
    `Real-world context: ${task.realWorldContext}`,
    `Scenario: ${task.scenario}`,
    `What students will do: ${task.studentChallenge}`,
    `Curriculum connection: ${task.curriculumConnection}`]

  },
  {
    kind: "bullets",
    title: `Task ${index + 1} · Success indicators`,
    bullets: task.successIndicators
  }]
  )];


  return {
    filename: sanitizeFilename(`${result.topicLabel} real-world-tasks`, "real-world-task"),
    title: result.pageTitle,
    subject: result.curriculumLabel,
    author: "Tema Real-World Task Generator",
    slides
  };
}